import CommonDrawer from "../../../App/commonDrawer"
import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import { Table, Space, message } from "antd";
import defaultPng from "assets/images/home/defaultPng.png";
import editI from "assets/images/home/editI.png";
import AllInviteDrawer from './AllInviteDrawer';
import Nodata from "assets/images/home/nodata.png";
import {put_defaultInviteCode} from "@/api/referral";

const {useTranslation, useDocumentWidth} = Hooks;
const {getOrigin, getUrl} = Util;

function SelectiveDrawer (props) {
  const { isShowModal, onClose, inviteCodeList, getInviteCodeList, getProfileInfo } = props;
  const t = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const [isShowAllModal, setIsShowAllModal] = useState(false)
  const [isShowAddInviteModal, setIsShowAddInviteModal] = useState(false)

  const onOkAllModal = () => {
    setIsShowAllModal(true)
  }

  const onCloseAllModal = () => {
    setIsShowAllModal(false)
  }

  const onCloseAddInviteModal = () => {
    setIsShowAddInviteModal(false)
  }

  const onOkAddInviteModal = () => {
    setIsShowAddInviteModal(true)
  }

  // 切换默认链接
  const defaultInit = (id) => {
    put_defaultInviteCode({
      successPop: true,
      data:{id}
    }).then(()=>{
      getProfileInfo()
      getInviteCodeList()
    })
  }

  return (
    <>
      <CommonDrawer title={t("home.recommendAll")} isShowModal={isShowModal} onClose={onClose} height={526}>
        <div className="selectiveDrawer">
          <div className="invitation_t">
            <div className="header">
              <div>{t("home.invitationCode")}</div>
              <div>{t("home.conversionRatio")}</div>
            </div>
            {inviteCodeList.length != 0 && inviteCodeList?.map((item) => (
              <div
                key={item.id ?? item.inviteCode}
                className="invitation"
                onClick={() => !item.isDefault && defaultInit(item.id)}
                style={!item.isDefault ? { cursor: "pointer" } : {}}
              >
                <div className="invitation_l">
                  <div className="invitation_ll">
                    <div className="inviteCode">{item.inviteCode}</div>
                    <div className="remark">{item.remark ? item.remark : "--"}</div>
                  </div>
                  {item.isDefault && <img src={defaultPng} alt="" />}
                </div>
                <div className="invitation_r">
                  <div className="my">{t("console.manage.my")}{(item.selfCommissionRate * 100).toFixed(0) + "%"}</div>
                  <div className="friend">{t("console.manage.friend")}{(item.inviteeCommissionRate * 100).toFixed(0) + "%"}</div>
                </div>
              </div>
            ))}
            {inviteCodeList.length == 0 && <div className="nodata">
              <img src={Nodata} className="nodataImg" />
              <div className="nodataTitle">{ t("home.NoRecent") }</div>
            </div>}
          </div>
          <div className="invitation_b">
            <div className="invitation_bb">{t('home.createNumber')}<span>{20 - inviteCodeList.length}</span></div>
            <div className="invitation_edit">
              <div className="edit_i">
                <img src={editI} onClick={onOkAllModal} />
              </div>
              <div className="add_new" onClick={onOkAddInviteModal}>
                {t("home.addNew")}
              </div>
            </div>
          </div>
        </div>
      </CommonDrawer>
      <AllInviteDrawer isShowModal={isShowAllModal} onClose={onCloseAllModal} inviteCodeList={inviteCodeList} getInviteCodeList={getInviteCodeList} getProfileInfo={getProfileInfo} onOkAddInviteModal={onOkAddInviteModal} onCloseAddInviteModal={onCloseAddInviteModal} isShowAddInviteModal={isShowAddInviteModal} />
    </>
  )
}

export default SelectiveDrawer


